import { Tooltip } from '@material-ui/core'

import Button from '@/components/button'
import { useCreatePulverizationMap } from '@/pages/diagnosis-view/contexts/create-pulverization-map-context'

import { useStyles } from './styles'

interface StyledButtonProps extends React.ComponentProps<typeof Button> {
  active: boolean
  label: string
}

const StyledButton = ({
  active,
  children,
  onClick,
  disabled,
  loading,
  label,
  type,
}: StyledButtonProps) => {
  const classes = useStyles()
  return (
    <Tooltip
      title={label}
      placement='top'
      classes={{
        tooltip: classes.tooltip,
        tooltipPlacementTop: classes.tooltipPlacementTop,
      }}
    >
      <span>
        <Button
          outlined={!active}
          style={{
            color: active ? 'white' : '',
          }}
          onClick={onClick}
          disabled={disabled}
          loading={loading}
          aria-label={label}
          type={type}
        >
          {children}
        </Button>
      </span>
    </Tooltip>
  )
}

export function StepperMenu() {
  const classes = useStyles()

  const {
    step,
    setStep,
    pulverizationData,
    processDemandResumeMutation: { isLoading },
    canRestartPulverization,
  } = useCreatePulverizationMap()

  return (
    <div className={classes.container}>
      <StyledButton
        label='Seleção de camadas'
        active={step === 1}
        onClick={() => setStep(1)}
        disabled={!canRestartPulverization}
      >
        <span className='material-symbols-outlined'>checklist_rtl</span>
      </StyledButton>
      <StyledButton
        label='Mesclagem de camadas'
        active={step === 2}
        onClick={() => setStep(2)}
        disabled={!canRestartPulverization}
      >
        <span className='material-symbols-outlined'>cell_merge</span>
      </StyledButton>
      <StyledButton
        label='Buffer de pulverização'
        active={step === 3}
        onClick={() => setStep(3)}
        disabled={!canRestartPulverization}
      >
        <span className='material-symbols-outlined rotate'>sprinkler</span>
      </StyledButton>
      <StyledButton
        label='Tratamento com defensivos'
        active={step === 4}
        onClick={() => setStep(4)}
        disabled={!canRestartPulverization}
      >
        <span className='material-symbols-outlined'>gas_meter</span>
      </StyledButton>
      <StyledButton
        label='Displays de equipamento'
        active={step === 5}
        onClick={() => setStep(5)}
        disabled={!canRestartPulverization}
      >
        <span className='material-symbols-outlined'>agriculture</span>
      </StyledButton>
      <StyledButton
        label='Resumo de pulverização'
        active={step === 6}
        loading={isLoading}
        onClick={() => (pulverizationData ? setStep(6) : setStep(5))}
      >
        <span className='material-symbols-outlined'>assignment</span>
      </StyledButton>
    </div>
  )
}
